import React from 'react';
import TopNavigation from '@amzn/awsui-components-console/top-navigation';
import { useFederate } from '../../shared/contexts/FederateContext';
import { useRegion } from '../../shared/contexts/RegionContext';
import './TopNavigation.scss';

const PortalTopNavigation: React.FC = () => {
  const { userName } = useFederate();
  const { currentRegion, setCurrentRegion } = useRegion();

  const handleRegionChange = (itemId: string) => {
    console.log('Region change triggered:', itemId);
    if (itemId === 'global' || itemId === 'china') {
      console.log('Setting region to:', itemId);
      setCurrentRegion(itemId);
    }
  };

  const regionDisplayName = currentRegion === 'global' ? 'Global' : 'China';

  return (
    <div className="portal-top-navigation">
      <TopNavigation
        identity={{
          href: '#',
          title: 'GCR Content Connector Portal',
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            text: regionDisplayName,
            iconName: 'globe',
            onItemClick: ({ detail }) => handleRegionChange(detail.id),
            items: [
              {
                id: 'global',
                text: 'Global',
              },
              {
                id: 'china',
                text: 'China',
              },
            ],
          },
          {
            type: 'button',
            text: userName || 'User',
            iconName: 'user-profile',
          },
        ]}
      />
    </div>
  );
};

export default PortalTopNavigation;
